export default {
  api: {
    denied: "Je hebt geen rechten om dit te kunnen doen"
  }
}
